import React from 'react';

export default function TigerTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="14.74,31.55 6.85,31.55 12.79,14.72 20.68,14.72" fill="#824D36" />
      <polygon points="11.17,8.51 19.06,8.51 20.68,14.72 12.79,14.72" fill="#BD7C60" opacity="0.92" />
      <polygon points="6.85,31.55 5.23,25.34 11.17,8.51 12.79,14.72" fill="#392218" opacity="0.95" />
      <polygon points="31.12,38.0 23.48,38.0 23.48,30.36 31.12,30.36" fill="#824D36" />
      <polygon points="23.48,38.0 31.12,38.0 22.72,33.8 15.08,33.8" fill="#392218" opacity="0.95" />
      <polygon points="23.48,38.0 15.08,33.8 15.08,26.16 23.48,30.36" fill="#392218" opacity="0.95" />
      <polygon points="33.15,21.08 25.77,21.08 27.39,16.49 34.77,16.49" fill="#824D36" />
      <polygon points="23.61,2.0 30.99,2.0 34.77,16.49 27.39,16.49" fill="#BD7C60" opacity="0.92" />
      <polygon points="25.77,21.08 21.99,6.59 23.61,2.0 27.39,16.49" fill="#392218" opacity="0.95" />
    </svg>
  );
}
